import React, { useEffect, useState } from 'react';
import Card from 'components/card/Card';
import { Tab, Tabs, TabList, TabPanels, TabPanel, useToast, Text } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { useAuth } from 'auth-context/auth.context';
import TableData from 'views/admin/serviceTicket/components/ticketTable';
import CustomerDetails from './customerDetails/customerDetails';
import CheckTable from 'views/admin/customerSavingPlans/components/CheckTable';
import OrderTable from 'views/admin/orders/components/CheckTable';
import LockerTable from 'views/admin/lockers/components/CheckTable';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import CommunicationTable from 'views/admin/userCommunication/components/communicationTable';
import DeviceTable from './audit/deviceTable';

export default function ViewCustomerDetail(props) {
  const { user, verifiedCustomerId } = useAuth();
  const history = useHistory();
  const toast = useToast();
  const id = IdFromUrl(window.location.href);

  useEffect(() => {
    if (user?.user_type === 'SHOWROOM' && id !== verifiedCustomerId) {
      toast({
        title: 'Access Denied',
        description: 'You must verify the customer via OTP before accessing their details.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      history.push('/admin/showroom-customer-access');
    }
  }, [user, id, verifiedCustomerId, history, toast]);

  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }
  const { getPermissionsForModule } = usePermissions();
  const [orderPermission, setOrderPermissions] = useState(null);
  const [PlanPermission, setPlanPermissions] = useState(null);
  const [lockersPermissions, setLockersPermissions] = useState(null);
  const [ticketPermissions, setTicketPermissions] = useState(null);
  const [communicationPermission, setCommunicationPermission] = useState(null);
  const [customerData, setCustomerData] = useState(); // State managed in the parent component

  // Form States:-

  useEffect(() => {
    const OrderPermissions = getPermissionsForModule([Modules.Orders]);
    setOrderPermissions(OrderPermissions);
    const PlanPermissions = getPermissionsForModule([Modules.SavingPlan]);
    setPlanPermissions(PlanPermissions);
    const lockersPermissions = getPermissionsForModule([Modules.Lockers]);
    setLockersPermissions(lockersPermissions);
    const ticketPermissions = getPermissionsForModule([Modules.CustomerTicket]);
    setTicketPermissions(ticketPermissions);
    const communicationPermission = getPermissionsForModule([Modules.CustomerTicket]);
    setCommunicationPermission(communicationPermission);
  }, []);

  return (
    <>
      <Card
        direction='column'
        w='100%'
        px='20px'
        mt='7rem'
        overflowX={{ sm: 'scroll', lg: 'hidden' }}
      >
        <Tabs isFitted variant='enclosed'>
          <TabList mb='1em'>
            <Tab>Customer Details</Tab>
            {ticketPermissions && ticketPermissions?.read && <Tab>Tickets</Tab>}
            {PlanPermission && PlanPermission?.read && <Tab>Saving Plans</Tab>}
            {orderPermission && orderPermission?.read && <Tab>Orders</Tab>}
            {lockersPermissions && lockersPermissions?.read && (
              <Tab>Advance Book</Tab>
            )}
            {(user?.user_type === 'SUPER_ADMIN' || user?.user_type === 'ADMIN') && <Tab>Audit</Tab>}
          </TabList>
          <TabPanels>
            <TabPanel>
              <CustomerDetails
                customerData={customerData}
                setCustomerData={setCustomerData} // Pass setter as prop
              />
            </TabPanel>
            {ticketPermissions && ticketPermissions?.read && (
              <TabPanel borderRadius={16} bgColor='gray.200' mt={0} pt={5}>
                {communicationPermission && communicationPermission?.read && (
                  <>
                    <Text fontSize='lg' fontWeight='700' mb='0px' mt='0px'>
                      User Communications
                    </Text>
                    <CommunicationTable withId={true} />
                  </>
                )}
                <Text fontSize='lg' fontWeight='700' mb='0px' mt='15px'>
                  Tickets
                </Text>
                <TableData withId={true} />
              </TabPanel>
            )}
            {PlanPermission && PlanPermission?.read && (
              <TabPanel borderRadius={16} bgColor='gray.200' mt={0} pt={5}>
                <CheckTable customerData={customerData} withId={true} />
              </TabPanel>
            )}
            {orderPermission && orderPermission?.read && (
              <TabPanel borderRadius={16} bgColor='gray.200' mt={0} pt={5}>
                <OrderTable withId={true} />
              </TabPanel>
            )}
            {lockersPermissions && lockersPermissions?.read && (
              <TabPanel borderRadius={16} bgColor='gray.200' mt={0} pt={5}>
                <LockerTable withId={true} />
              </TabPanel>
            )}
            {(user?.user_type === 'SUPER_ADMIN' || user?.user_type === 'ADMIN') && (
              <TabPanel>
                <DeviceTable userId={id} />
              </TabPanel>
            )}
          </TabPanels>
        </Tabs>
      </Card>
    </>
  );
}
